import { useState, useEffect } from 'react';
import { getConsent, setConsent, loadPixel } from '../lib/pixel.js';

// Small bottom-left notice. Accepting loads the Meta Pixel; declining keeps it off.
// Other tools (Vercel Analytics, Brevo, OptiMonk) load regardless, so the copy says so.
export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = getConsent();
    if (stored === 'accepted') loadPixel();
    else if (!stored) setVisible(true);
  }, []);

  if (!visible) return null;

  const choose = (value) => {
    setConsent(value);
    if (value === 'accepted') loadPixel();
    setVisible(false);
  };

  const btn = {
    border: 'none', borderRadius: '50px', padding: '0.45rem 1rem', fontSize: '0.78rem',
    fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit',
  };

  return (
    <div role="dialog" aria-label="Cookie and data privacy notice" style={{
      position: 'fixed', left: '1rem', bottom: '1rem', zIndex: 1000, maxWidth: '340px',
      background: 'rgba(23,20,15,0.96)', color: 'rgba(255,255,255,0.85)',
      borderRadius: '14px', padding: '1rem 1.1rem', boxShadow: '0 8px 30px rgba(0,0,0,0.25)',
      fontFamily: "'Inter', sans-serif", fontSize: '0.8rem', lineHeight: 1.55,
    }}>
      <p style={{ margin: '0 0 0.8rem' }}>
        We use cookies to measure our ads on Meta, and only if you accept. Declining turns that off.
        Basic site analytics and our newsletter and pop-up tools still run. We never sell your personal information.
      </p>
      <div style={{ display: 'flex', gap: '0.5rem' }}>
        <button onClick={() => choose('accepted')} style={{ ...btn, background: '#E5822C', color: 'white' }}>Accept</button>
        <button onClick={() => choose('declined')} style={{ ...btn, background: 'rgba(255,255,255,0.12)', color: 'white' }}>Decline</button>
      </div>
    </div>
  );
}
